<script>
export default {
  props: {
    message: {
      default: "We're sorry, something went wrong.",
      type: String,
    },
  },
  data: () => ({
    error: false,
  }),
  errorCaptured() {
    this.error = true
  },
  render(h) {
    return this.error ? h('p', this.message) : this.$slots.default[0]
  },
}
</script>
